export const NER_POS_MODELS = {
  roberta_nepali: "RoBERTa Nepali",
  mbert: "mBERT"
} as const

export const nerPosConfig = {
  id: "nerpos",
  title: "Named Entity Recognition and Part of Speech Tagging",
  endpoint: import.meta.env.VITE_API_ENDPOINT,
  available_models: NER_POS_MODELS,
  input_text_min_length: 2,
} as const